var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-avatar',{staticClass:"border-2 border-solid border-white",attrs:{"src":require(`@/assets/images/portrait/icons/${_vm.params.data.channel}`)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }